import { GetServerSidePropsContext } from "next";
import dynamic from "next/dynamic";

import GeneralHead from "@logics/tags/GeneralHead";
import { loadLocaleProps } from "@logics/utils/i18n";

const Landing = dynamic(() => import("@domains/intro/views/Landing/Landing"), {
  ssr: false,
});

const Home = () => {
  return (
    <>
      <GeneralHead />

      <Landing />
    </>
  );
};

export default Home;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return {
    props: {
      ...(await loadLocaleProps(context)),
    },
  };
}
